import {DayReport} from "@/data/entities/dayReport";
import {formatMoney} from "@/utils/MoneyUtils";
import {TableColumnProps} from "peggirkit/dist/components/Table/TableElements/Head/TableHeadColumn";
import {formatHoursMinutes, reportPeriod} from "@widgets/reports/dayReport/DayReportUtils";
import {formatPeriod} from "@widgets/reports/dayReport/period/ReportPeriod";

/**
 * A column of the day report summary. The summary table and the CSV export
 * both use these columns, so they always contain the same.
 */
export type DayReportSummaryColumn = Omit<TableColumnProps<DayReport>, "label"> & {
    header: string,
    // Value in the CSV file: amounts with a decimal point, counts as numbers
    csvValue: (dayReport: DayReport) => string | number,
    // Value in the table
    displayValue: (dayReport: DayReport) => string | number,
    alignRight: boolean,
};

const csvAmount = (amount: number): string => amount.toFixed(2);

export const dayReportSummaryColumns: DayReportSummaryColumn[] = [
    {
        header: "Periode",
        id: "from",
        csvValue: r => formatPeriod(reportPeriod(r)),
        displayValue: r => formatPeriod(reportPeriod(r)),
        alignRight: false,
    },
    {
        id: "onlinePaidOrderCount",
        header: "Online betaald",
        csvValue: r => r.onlinePaidOrderCount,
        displayValue: r => r.onlinePaidOrderCount,
        alignRight: true,
    },
    {
        id: "inPersonPaidOrderCount",
        header: "Aan de deur betaald",
        csvValue: r => r.inPersonPaidOrderCount,
        displayValue: r => r.inPersonPaidOrderCount,
        alignRight: true,
    },
    {
        id: "cancelledOrderCount",
        header: "Geannuleerd",
        csvValue: r => r.cancelledOrderCount,
        displayValue: r => r.cancelledOrderCount,
        alignRight: true,
    },
    {
        id: "paidOnline",
        header: "Bruto-omzet Mollie",
        csvValue: r => csvAmount(r.paidOnline),
        displayValue: r => formatMoney(r.paidOnline),
        alignRight: true,
    },
    {
        id: "paidInPerson",
        header: "Bruto-omzet PIN",
        csvValue: r => csvAmount(r.paidInPerson),
        displayValue: r => formatMoney(r.paidInPerson),
        alignRight: true,
    },
    {
        id: "grossRevenue",
        header: "Bruto-omzet",
        csvValue: r => csvAmount(r.grossRevenue),
        displayValue: r => formatMoney(r.grossRevenue),
        alignRight: true,
    },
    {
        id: "vat",
        header: "Totaal btw",
        csvValue: r => csvAmount(r.vat),
        displayValue: r => formatMoney(r.vat),
        alignRight: true,
    },
    {
        id: "netRevenue",
        header: "Netto-omzet",
        csvValue: r => csvAmount(r.netRevenue),
        displayValue: r => formatMoney(r.netRevenue),
        alignRight: true,
    },
    {
        id: "workedMinutes",
        header: "Gewerkte tijd (hh:mm)",
        csvValue: r => formatHoursMinutes(r.workedMinutes),
        displayValue: r => formatHoursMinutes(r.workedMinutes),
        alignRight: true,
    },
];